import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext({ mode: 'auto', setMode: () => {} });

function resolve(mode) {
  if (mode === 'auto') {
    const prefersLight =
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-color-scheme: light)').matches;
    return prefersLight ? 'light' : 'dark';
  }
  return mode;
}

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => {
    try {
      const saved = localStorage.getItem('aihot-theme');
      return saved === 'light' || saved === 'dark' || saved === 'auto' ? saved : 'auto';
    } catch {
      return 'auto';
    }
  });

  useEffect(() => {
    const actual = resolve(mode);
    const root = document.documentElement;
    root.setAttribute('data-theme', actual);
    root.setAttribute('data-theme-mode', mode);
    const meta = document.getElementById('theme-color-dynamic');
    if (meta) meta.setAttribute('content', actual === 'light' ? '#f4f5f6' : '#10151c');
    try {
      localStorage.setItem('aihot-theme', mode);
    } catch {
      /* ignore */
    }
  }, [mode]);

  // 跟随系统时，监听系统主题变化实时切换
  useEffect(() => {
    if (mode !== 'auto') return;
    const mq = window.matchMedia('(prefers-color-scheme: light)');
    const handler = () => {
      const actual = mq.matches ? 'light' : 'dark';
      document.documentElement.setAttribute('data-theme', actual);
    };
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [mode]);

  return (
    <ThemeContext.Provider value={{ mode, setMode, actual: resolve(mode) }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
